import Menu from "./menu.vue";
import MenuItem from "./menu-item.vue";

Menu.Item = MenuItem;

export default Menu;
